// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

type EshopOrderType = "ESHOP_REORDER" | "ESHOP_ADD_TO_WATCHLIST";

@JsonObject('ProjectOrderDTO')
export class ProjectOrderDTO {

  @JsonProperty('projectId', 'Number')
  public projectId: number = undefined;
  @JsonProperty('projectVersion', 'Number')
  public projectVersion: number = undefined;
  @JsonProperty('orderType', 'String')
  public orderType: EshopOrderType = undefined;
  @JsonProperty('language', 'String')
  public language: string = undefined;
  @JsonProperty('watchList', 'String')
  public watchList: string = undefined;

}
